document.addEventListener("DOMContentLoaded", () => {
          
    // Showing tooltip content on page load.


    jQuery( ".stc_content" ).each(function( index ) {
        let getPrice = jQuery(this).find('ul').find('.divide_buy').find('.stc_item').attr('data-price');
        displayTooltip(getPrice,index);
      });
   


   
    
    // Displaying tooltip on click of label.
    jQuery(document).on('click', '.dividebuy_tooltip_open', function() {
      tooltipPosition();
      jQuery(this).parent().parent().find('.dividebuy-tooltip').css("display","block");
      displayTooltip();
    });
    
    // Close the tooltip on X icon.
    jQuery(document).on('click', '#dividebuy-tooltip-close', function() {
      jQuery(".dividebuy-tooltip").css("display", "none");  
    });
    
    /**
    * Displaying tooltip based on product quantity changed by user.
    *
    * The classes used here are of standard shopify theme and
    * need to be change depending of retailer theme.
    */
    jQuery(document).on('keyup change', '.js-qty .js-qty__input, input[name="quantity"], .quantity input', function() {
      displayTooltip();
    });
    
    /**
    * Displaying tooltip based on product quantity changed by user clicking on buttons.
    *
    * The classes used here are of standard shopify theme and
    * need to be change depending of retailer theme.
    */
    jQuery(document).on('click', '.js-qty .js-qty__adjust--plus, .js-qty .js-qty__adjust--minus, .quantity .quantity__button', function() {
      displayTooltip();
    });
    
    /**
    * Displaying tooltip based on product variant changed by user.
    *
    * The classes used here are of standard shopify theme and
    * need to be change depending of retailer theme.
    */
    jQuery(document).on("click",".product-form__input label",function(){
      setTimeout(function() {
        displayTooltip();
      }, 1500);
    });
    
    
  jQuery(".price__regular .price-item.price-item--regular").on("DOMSubtreeModified", function(event) {    
    
    if(jQuery('.price__sale dd').css('display')=="none"){  
      setTimeout(function() {
        var price = 
       displayTooltip(price);   
      }, 1500);
        
    }
  });		
    // Function to get minimum instalment value and tooltip content.
    function displayTooltip(price,order) {      
      // Getting minimum order value and instalments.
      var instalments = unserialize(jQuery('.stc_item').attr('data-installments'));

      console.log(instalments);

      var minimumOrder = getOrderAmount(instalments);
    
      // Getting dynamic product price
      var productPrice = price;
  
      productPrice = parseFloat(productPrice);


      console.log(productPrice);

      // Getting dynamic product quantity
      var productQty = 1;
      if(jQuery('.quantity input[name="quantity"]').length > 0) {
        // replace this with product quantity class used in retailer theme
        productQty = jQuery('.quantity input[name="quantity"]:first').val();
      }
      productQty = parseInt(productQty);

      
      
      // calculate cart total + (product price * quantity)
      var productPriceWithoutCurrency = productPrice * productQty;
    
      // Condition for show and hide the dividebuy banner based on minimum instalment value
      
      var tootltipHtml = '';
      var lastActiveInst = 0;
      
      // Function for generating tooltip content to be displayed in product page.
      for(value in instalments) {
        var month = instalments[value].key;
        var spendCost = instalments[value].value;
        var monthCost = (productPriceWithoutCurrency / instalments[value].key).toFixed(2);
        if(parseFloat(productPriceWithoutCurrency) >= parseFloat(instalments[value].value)) {
            tootltipHtml += '<div class="dividebuy-instalment">';
            tootltipHtml += '<div class="dividebuy-monthly-instalments"> <span>'+month+' </span>';
            tootltipHtml += 'payments of </div>';
            tootltipHtml += '<div class="dividebuy-installment-amount"> £'+monthCost+' </div>';
            tootltipHtml += '</div>';
            lastActiveInst = (productPriceWithoutCurrency / instalments[value].key);
        } else  {
          tootltipHtml += '<div class="dividebuy-instalment dividebuy-instalment-disabled">';
          tootltipHtml += '<div class="dividebuy-spend-text"> Spend a minimum of £'+parseFloat(spendCost).toFixed(2)+' to unlock: </div>';
          tootltipHtml += '<div class="dividebuy-monthly-instalments"> <span>'+month+' </span>';
          tootltipHtml += 'payments of </div>';
          tootltipHtml += '<div class="dividebuy-installment-amount"> £'+ (instalments[value].value / instalments[value].key).toFixed(2) +' </div>';
          tootltipHtml += '</div>';
        }
      }
      
      tootltipHtml += '<div class="dividebuy-instalment-total">';
      tootltipHtml += '<div class="dividebuy-instalment-total-text">Interest: <span>£0.00</span></div>';
      tootltipHtml += '<div class="dividebuy-instalment-total-amount">Total: <span>£'+parseFloat(productPriceWithoutCurrency).toFixed(2)+'</span></div>';
      tootltipHtml += '</div>';

      console.log('K: '+((parseFloat(lastActiveInst).toFixed(2))));
      
      jQuery(".dividebuy-tooltip-content").eq(order).html(tootltipHtml);
      jQuery(".dividebuy-lowest").eq(order).html('£'+formatNumber(parseFloat(lastActiveInst).toFixed(2)));
     
      if (((parseFloat(lastActiveInst).toFixed(2))) !== "0.00"){
        //jQuery("#spread-cost_section").html('FROM £'+formatNumber(parseFloat(lastActiveInst).toFixed(2))+' PER MONTH');
        jQuery('.stc_header_content').eq(order).find('p').html('FROM £'+formatNumber(parseFloat(lastActiveInst).toFixed(2))+' PER MONTH')
      }else{
        jQuery('.stc_header_content').eq(order).find('p').html('');
        jQuery('.divide_buy').eq(order).remove();
      }
    }
    
    // number formation for total
    function formatNumber(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    }
  });